const i18nCheckConfig = require('./i18n.config.json')

// used for SSR (getServerSideProps)
// const path = require('path')
// const localePath = path.resolve('./public/locales')

module.exports = {
  debug:
    process.env.NODE_ENV === 'development' && process.env.DEBUG_I18N === 'true',
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'de', 'pt', 'es', 'fr', 'it', 'ja', 'ko', 'pl'],
  },
  fallbackLng: 'en',
  sourceOnlyNamespaces: i18nCheckConfig.catalogs.sourceOnly.map((file) =>
    file.replace(/\.json$/, ''),
  ),
  // localePath,
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  // serializeConfig: false,
}
